import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from 'gw-digital-auth-react';
import { Avatar, ModalService} from '@jutro/components';
import ClaimFnolInfoTemplate from '../ClaimFnolInfoTemplate/ClaimFnolInfoTemplate';
import { ApplicationHeader, DropdownMenuLink, DropdownMenuAvatar, DropdownMenuSeparator } from '@jutro/router';
import metadata from './PageHeaderComponent.metadata.json5';
import pageHeaderStyles from './PageHeaderComponent.module.scss';
import messages from './PageHeaderComponent.messages';

function PageHeaderComponent(props) {
    const auth = useAuthentication();
    const { routes, history, logout } = props;
    const translator = useContext(TranslatorContext);
    const { env } = appConfig;  
    const breakpoint = useContext(BreakpointTrackerContext); 

    const onFileAClaimButtonClick = useCallback(
        (event) => {
            
            /* return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            }); */
			event.preventDefault();
            ModalService.showInfo({
                title: <h3>{translator(messages.reportClaim)}</h3>,
                message: <ClaimFnolInfoTemplate />
            });

        },
        [props, translator]
    );

    const getMobileAvatar = useCallback(() => {
        return (<div className="avatarContainer" tabindex="-1">
                    <div tabindex="-1">
                        <Avatar
                            id="Avatar"
                            size="large"
                            useAuthInfo={false}
                            username={auth.user_name}
                            title={_.capitalize(auth.name)}
                            subtitle={_.capitalize(auth.user_name)}
                            tabindex="-1"
                        />
                    </div>
                    <div tabindex="-1" className="avatarTitleContainer">
                        <h4>{auth.name}</h4>
                        {auth.user_name}
                    </div>
                </div>
            )
    },[auth])
    

    const getAvatarLinks = useCallback(() => {
        // Need to add the below line to links array, if My Account link to get displayed
        //<DropdownMenuLink to="/userprofile">{translator(messages.account)}</DropdownMenuLink>,

        let links = [
            <DropdownMenuSeparator></DropdownMenuSeparator>,
            getMobileAvatar(),
            <DropdownMenuSeparator></DropdownMenuSeparator>,
            <DropdownMenuLink to="/home">{translator(messages.home)}</DropdownMenuLink>,
            <DropdownMenuLink to="/claims">{translator(messages.myClaims)}</DropdownMenuLink>,
            <DropdownMenuLink to="/billing-summary">{translator(messages.myBillings)}</DropdownMenuLink>,
            <DropdownMenuLink to="/account-documents-summary">{translator(messages.myDocuments)}</DropdownMenuLink>,
            // <DropdownMenuLink to="/faq">{translator(messages.faq)}</DropdownMenuLink>
        ];

        if(breakpoint === 'phone'){
            links.push(                
                <DropdownMenuLink href="https://trilliummutual.com/payment/">{translator(messages.makePayment)}</DropdownMenuLink>,
                <DropdownMenuLink onClick={onFileAClaimButtonClick}>{translator(messages.reportClaim)}</DropdownMenuLink>
            )
        }

        links = (breakpoint === 'phone') ? links : [
            <DropdownMenuSeparator></DropdownMenuSeparator>,
            getMobileAvatar(),
            <DropdownMenuSeparator></DropdownMenuSeparator>
        ];
        // when using jutroAuthContext, jutro application header add the logout link by default
        // avoiding custom logout for gwcp and follow jutro
        if (!auth.useJutroAuthContext) {
            links.push(
                <DropdownMenuLink onClick={auth.logout}>{translator(messages.logout)}</DropdownMenuLink>
            );
        }
        return links;
    }, [translator, auth]);

    const getLogoSrc = useCallback(() => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        const breakpoint = useContext(BreakpointTrackerContext);
        //const logoUrl = breakpoint === 'desktop' ? `${url}/branding/eylogo.png` : `${url}/branding/eylogo.png`
        const logoUrl = (breakpoint === 'phone') ? `${url}/branding/Trillium_Primary_Logo_RGB.png` : `${url}/branding/Trillium_Secondary_Logo_Horizontal_RGB.png`       
       return logoUrl;
    }, [env]);

    const overrides = {
        applicationheader: {
            avatarProps: {
                username: auth.user_name,
                title: auth.name,
                subtitle: auth.user_name
            },
            avatarChildren:  getAvatarLinks(),
            logoSrc: getLogoSrc(),
            navigationRoutes: routes
        },
        gwAuthStatus: {
            username: auth.user_name,
            title: 'Profile',
            subtitle: _.capitalize(auth.user_name)[0] || '',
            content: getAvatarLinks(),
            //buttonText: _.capitalize(auth.user_name)[0] || '',
        },
        navMenuBarContainer:{
            visible: breakpoint == 'phone'
        },
        dropdownMenuButton:{
            content: getAvatarLinks()
        }
    };

    

    const resolvers = {
        resolveClassNameMap: pageHeaderStyles,
        resolveComponentMap: {
            applicationheader: ApplicationHeader
        },
        resolveCallbackMap:{
            onFileAClaimButtonClick: onFileAClaimButtonClick,
            goToLogout: auth.logout
        }
    };

    

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PageHeaderComponent.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(PageHeaderComponent);
